module.exports = __webpack_public_path__ + "fonts/iconfont.b9bcba6.ttf";